import axios from "axios";

// 创建 axios 实例
const axiosInstance = axios.create({
  baseURL: "http://8.219.239.191:5000/", // 阿里云服务器后端API
  // baseURL: "http://192.168.245.129:5000/", //本地调试虚拟机后端API
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export default axiosInstance;
